// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mnd-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter";
  font-size: 3rem;
  letter-spacing: 1rem;
  margin-top: 4rem;
  text-align: center;
}

@media (max-width: 1077px) {
  .mnd-header {
    font-size: 1.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".mnd-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Inter\";\n  font-size: 3rem;\n  letter-spacing: 1rem;\n  margin-top: 4rem;\n  text-align: center;\n}\n\n@media (max-width: 1077px) {\n  .mnd-header {\n    font-size: 1.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
